import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-bachelors-degree-after-twelve-commerce',
  templateUrl: './bachelors-degree-after-twelve-commerce.component.html',
  styleUrls: ['./bachelors-degree-after-twelve-commerce.component.scss']
})
export class BachelorsDegreeAfterTwelveCommerceComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
